import { FlexBox, Position, Text } from '@trmediaab/zebra';

import Img from '~/components/Img';
import { ThemedLink } from '~/components/ThemedLink';

export default function AuthorItem({ author }) {
  return (
    <ThemedLink
      to={{
        type: 'AUTHOR',
        payload: {
          slug: author.slug,
        },
      }}
      sx={{
        display: 'block',
        "&:hover [data-id='headline'] ": {
          textDecoration: 'underline',
        },
      }}
    >
      <FlexBox
        flexDirection="row"
        bg="white"
        gap="3"
        alignItems="center"
        sx={{ position: 'relative' }}
        minHeight={76}
      >
        <Text
          flex={1}
          fontWeight="bold"
          color="brands.travrondenSpel"
          data-id="headline"
          lineHeight="tight"
          fontSize={3}
          px="3"
          py="3"
        >
          {author.firstname} {author.lastname}
        </Text>

        <Position.absolute right={0} bottom={0}>
          <Img width={64} aspectRatio={[1, 1]} image={author.image} />
        </Position.absolute>
      </FlexBox>
    </ThemedLink>
  );
}
